import { Currency } from "@app/components/common/currency-converter/types";

export enum Period {
  YEAR_TO_DAY = "ytd",
  ONE_MONTH = "1m",
  SIX_MONTH = "6m",
  ONE_YEAR = "1y",
}

export type State = {
  rates: Record<string, Record<Currency, number>> | null;
  isLoading: boolean;
  isError: boolean;
};
